import { generatePath, useNavigate } from 'react-router'
import { ConfirmActionModal } from '@/components/commons/confirm-action-modal'
import { useUpdateStepToRetouchingQaCompleted } from '@/features/photoset/queries/use-update-step-to-retouching-qa-completed'
import type { Photoset } from '@/features/photoset/types'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS, queryClient } from '@/query-client'
import { routes } from '@/routes'
import { useTranslation } from '@/translations/i18n'

export const RetouchingQaConfirmationModal = ({
	photosetId,
	onClose
}: {
	photosetId: Photoset['id']
	onClose: () => void
}) => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const updateStepToRetouchingQaCompletedMutation =
		useUpdateStepToRetouchingQaCompleted({
			onError: (error) => errorHandler(error),
			onSuccess: () => {
				queryClient.invalidateQueries({
					queryKey: [QUERY_KEYS.PHOTOSET]
				})

				navigate(
					generatePath(routes.PHOTOSET_RETOUCHING_QA_COMPLETED.path, {
						id: String(photosetId)
					})
				)
			}
		})

	return (
		<ConfirmActionModal
			headerTitle=''
			isLoading={updateStepToRetouchingQaCompletedMutation.isPending}
			onClose={onClose}
			onConfirm={() =>
				updateStepToRetouchingQaCompletedMutation.mutate(photosetId)
			}
			paragraph={t('photoset:vetting_qa.confirmation_modal_paragraph')}
			title={t('photoset:vetting_qa.confirmation_modal_title')}
		/>
	)
}
